import { z } from 'zod';

export const userAddressSchema = z.object({
  edit: z
    .object({
      address_id: z.string().min(1),
    })
    .optional(),
  street: z.string().min(1, 'Rua é obrigatória'),
  number: z.string().min(1, 'Número é obrigatório'),
  complement: z.string().default('').optional(),
  reference: z.string().default('').optional(),
  district: z.string().default('').optional(),
  city: z.string().min(1, 'Cidade é obrigatória'),
  state: z.string().min(1, 'Estado é obrigatório'),
  cep: z.string().default('').optional(),
  coordinates: z.object({
    latitude: z.number(),
    longitude: z.number(),
  }).optional().default({ latitude: 0, longitude: 0 }),
});

export type UserAddressSchema = z.infer<typeof userAddressSchema>;

export const selectedPlaceSchema = z.object({
  place_address: z.string(),
  place_neighborhood: z.string(),
  place_city: z.string(),
  place_state: z.string(),
  place_zip_code: z.string(),
});

export type SelectedPlaceSchema = z.infer<typeof selectedPlaceSchema>;
